import React, { useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import { Autocomplete, TextField } from '@mui/material'
import './dropdown.css'

export interface DropDownFilterProps {
  data: any
  onTitleFilterChange: (value: string) => void
  label: string
}

const DropDownFilter = (props: DropDownFilterProps) => {
  const { data, onTitleFilterChange, label } = props
  const [value, setValue] = useState<any>(null)
  return (
    <Autocomplete
      value={value}
      options={data}
      onChange={(e, newValue) => {
        setValue(newValue)
        onTitleFilterChange(newValue)
      }}
      className={'dropdown'}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: <>{params.InputProps.endAdornment}</>
            }}
          />
        )
      }}
    />
  )
}

export default DropDownFilter
